import API from "../../api/api";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const EwalletService = {
    callTiles: async () => {
        return callApi("ewallet-tiles");
    },
    
    callgTiles: async () => {
        return callApi("gg-wallet-tiles");
    },
    callRealTiles: async () => {
        return callApi("real-wallet-tiles");
    },
     callLotteryTiles: async () => {
        return callApi("lottery-wallet-tiles");
    },
    callRStatement: async (page, itemsPerPage,projects) => {
        return callApi(`real-wallet-statement?page=${page}&perPage=${itemsPerPage}&project=${projects}`)
    },
    callStatement: async (page, itemsPerPage,project) => {
        return callApi(`ewallet-statement?page=${page}&perPage=${itemsPerPage}&project=${project}`)
    },
    callLStatement: async (page, itemsPerPage,project) => {
        return callApi(`lottery-wallet-statement?page=${page}&perPage=${itemsPerPage}`)
    },
    callGStatement: async (page, itemsPerPage) => {
        return callApi(`gg-wallet-statement?page=${page}&perPage=${itemsPerPage}`)
    },
    callTransferHistory: async (page, itemsPerPage, selectedCategory, startDate, endDate,project) => {
        return callApi(`/ewallet-transfer-history?type=${selectedCategory}&startDate=${startDate}&endDate=${endDate}&page=${page}&perPage=${itemsPerPage}&project=${project}`)
    },
    callPurchaseHistory: async (page, itemsPerPage) => {
        return callApi(`purchase-wallet?page=${page}&perPage=${itemsPerPage}`)
    },
    callMyEarnings: async (page, itemsPerPage, selectedCategory, startDate, endDate,project) => {
        return callApi(`my-earnings?page=${page}&perPage=${itemsPerPage}&startDate=${startDate}&endDate=${endDate}&direction=desc&type=${selectedCategory}&project=${project}`)
    },
    callEwalletBalance: async () => {
        return callApi('get-ewallet-balance')
    },
    callFundTransfer: async (data) => {
        return API.post("fund-transfer", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callInvestGGFC: async (data) => {
        return API.post("invest-ggfc", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callWithdrawGGFC: async (data) => {
        return API.post("withdraw-ggfc", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    callInvestmentReport: async () => {
        return callApi("ggfc-investment-report");
    },
    // New: server-side paginated investments list
    callInvestments: async (page, perPage, search = "", status = "", contract = "", token = "") => {
        return callApi(`ggfc-investments?page=${page}&perPage=${perPage}&search=${encodeURIComponent(search)}&status=${status}&contract=${encodeURIComponent(contract)}&token=${token}`)
    },
    // New: server-side monthly interest earnings with pagination & filters
    callInvestmentInterest: async (page, perPage, investmentId = "", month = "") => {
        return callApi(`ggfc-investment-interest?page=${page}&perPage=${perPage}&investment=${investmentId}&month=${month}`)
    },
    callWithdrawalReport: async (page = 1, perPage = 10, status = "", startDate = "", endDate = "") => {
        // Build query params dynamically (avoid sending 'all')
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("perPage", perPage);
        if (status) params.append("status", status);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        return callApi(`ggfc-withdrawal-report?${params.toString()}`);
    },
    callWithdrawWalletToken: async (data) => {
        return API.post("withdraw-wallet-token", JSON.stringify(data))
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    }   
}